const steps = [
  {
    step: "01",
    title: "Выберите событие и жанр",
    description: "День рождения, розыгрыш, признание — выберите повод и стиль музыки",
    emoji: "🎯",
  },
  {
    step: "02",
    title: "Получите демоверсию бесплатно",
    description: "AI напишет текст и создаст 20-секундный отрывок — без оплаты",
    emoji: "🎧",
  },
  {
    step: "03",
    title: "Купите полный хит за 249 ₽",
    description: "Скачайте полную версию в MP3 и удивляйте друзей",
    emoji: "🚀",
  },
];

const HowItWorks = () => {
  return (
    <section className="py-12 relative" id="how-it-works">
      <div className="container px-4 mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold mb-3 text-foreground">
            Как это <span className="text-gradient-primary">работает</span>
          </h2>
          <p className="text-muted-foreground text-base max-w-md mx-auto">
            Три простых шага до персонального хита
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {steps.map((step, index) => (
            <div
              key={step.step}
              className="relative p-6 rounded-2xl bg-card border border-border text-center"
            >
              <div className="w-10 h-10 rounded-full bg-primary text-primary-foreground font-display font-bold text-sm flex items-center justify-center mx-auto mb-4">
                {step.step}
              </div>
              <span className="text-3xl mb-3 block">{step.emoji}</span>
              <h3 className="font-display text-base font-semibold mb-2 text-foreground">{step.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{step.description}</p>

              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-3 text-muted-foreground text-xl">→</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
